import Altramuces from './../assets/img/allergens/Altramuces.png';
import Apio from './../assets/img/allergens/Apio.png';
import Cacahuetes from './../assets/img/allergens/Cacahuetes.png';
import Crustaceos from './../assets/img/allergens/Crustaceos.png';
import Dioxido_de_azufre_y_sulfitos from './../assets/img/allergens/Dioxido_de_azufre_y_sulfitos.png';
import Frutos_de_cascara from './../assets/img/allergens/Frutos_de_cascara.png';
import Gluten from './../assets/img/allergens/Gluten.png';
import Huevo from './../assets/img/allergens/Huevo.png';
import Lacteos from './../assets/img/allergens/Lacteos.png';
import Moluscos from './../assets/img/allergens/Moluscos.png';
import Mostaza from './../assets/img/allergens/Mostaza.png';
import Pescado from './../assets/img/allergens/Pescado.png';
import Sesamo from './../assets/img/allergens/Sesamo.png';
import Soja from './../assets/img/allergens/Soja.png';


export const allergens = [
    { id: 1,    label: 'Altramuces',                    icon: Altramuces },
    { id: 2,    label: 'Apio',                          icon: Apio },
    { id: 3,    label: 'Cacahuetes',                    icon: Cacahuetes },
    { id: 4,    label: 'Crustáceos',                    icon: Crustaceos },
    { id: 5,    label: 'Dióxido de azufre y sulfitos',  icon: Dioxido_de_azufre_y_sulfitos },
    { id: 6,    label: 'Frustos de cáscara',            icon: Frutos_de_cascara },
    { id: 7,    label: 'Gluten',                        icon: Gluten },
    { id: 8,    label: 'Huevo',                         icon: Huevo },
    { id: 9,    label: 'Lácteos',                       icon: Lacteos },
    { id: 10,   label: 'Moluscos',                      icon: Moluscos },
    { id: 11,   label: 'Mostaza',                       icon: Mostaza },
    { id: 12,   label: 'Pescado',                       icon: Pescado },
    { id: 13,   label: 'Sésamo',                        icon: Sesamo },
    { id: 14,   label: 'Soja',                          icon: Soja },
]